/**
 * Tooltip modules
 */
export * from './tooltip';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-popups/src/tooltip/index.js
// module id = 1854
// module chunks = 0